import React from "react";
import { Row, Col } from "antd";
import { motion } from "framer-motion";
import Heading from "../../components/heading";
import styles from "./about.module.scss";
import { ReactComponent as TeamSvg } from "../../assests/images/man-working-on-laptop.svg";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const AboutPage = () => {
  return (
    <div className={styles.wrapper}>
      {/* HERO */}
      <motion.section
        className={styles.hero}
        initial="hidden"
        animate="visible"
        variants={fadeUp}
        transition={{ duration: 0.6 }}
      >
        <Heading
          heading="About Shivant HR Consultancy"
          subheading="Your trusted recruitment partner for leadership and growth"
        />
      </motion.section>

      {/* WHO WE ARE */}
      <motion.section
        className={styles.section}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        transition={{ duration: 0.6 }}
      >
        <Row gutter={[48, 48]} align="middle">
          <Col xs={24} md={12}>
            <h2 className={styles.title}>Who We Are</h2>
            <p className={styles.text}>
              Headquartered in Delhi since 2022, Shivant HR Consultancy
              specializes in delivering high-quality talent solutions across
              IT, BFSI, Pharma, Agriculture, and multiple other industries.
              <br /><br />
              We believe recruitment is not about filling positions — it’s about
              building long-term partnerships by deeply understanding client
              needs and candidate aspirations.
            </p>
          </Col>

          <Col xs={24} md={12} className={styles.imageWrap}>
            <TeamSvg height={200}/>
          </Col>
        </Row>
      </motion.section>

      {/* WHY US */}
      <motion.section
        className={styles.sectionAlt}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        transition={{ duration: 0.6 }}
      >
        <h2 className={styles.centerTitle}>Why Choose Us</h2>

        <div className={styles.cards}>
          {[
            {
              title: "Client-Centric Approach",
              desc: "We first understand your business challenges before proposing solutions.",
            },
            {
              title: "Industry Expertise",
              desc: "Deep hiring experience across multiple industries and domains.",
            },
            {
              title: "Quality Over Quantity",
              desc: "We shortlist candidates based on skill, culture fit, and long-term value.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className={styles.card}
              whileHover={{ y: -8 }}
            >
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* HOW WE WORK */}
      <motion.section
        className={styles.section}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        transition={{ duration: 0.6 }}
      >
        <h2 className={styles.centerTitle}>How We Work</h2>

        <div className={styles.steps}>
          {[
            "Understand client requirements",
            "Define sourcing strategy",
            "Screen & assess candidates",
            "Deliver best-fit talent",
          ].map((step, index) => (
            <div key={index} className={styles.step}>
              <span>0{index + 1}</span>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </motion.section>

      {/* CTA */}
      <motion.section
        className={styles.cta}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        transition={{ duration: 0.6 }}
      >
        <h2>Let’s Build Your Team Together</h2>
        <p>Your royal path to reach the right talent</p>
      </motion.section>
    </div>
  );
};

export default AboutPage;
